module.exports = __webpack_public_path__ + "static/media/scroll_oval.c651ea9f.svg";